import React, { useState, useEffect, useContext } from 'react'

import styles from './ListaBeneficiarios.module.css'
import imgBtneditar from '../../img/btneditar.png'
import imgBtneliminar from '../../img/btneliminar.png'

import * as Funciones from '../../utils/funciones'
import * as Constantes from '../../utils/constantes'

import Subtitle from '../Subtitle/Subtitle'
import BarraProgreso from '../ProgresBar/BarraPorcentaje'
import BeneficiarioModal from '../BeneficiarioModal/BeneficiarioModal'
import Modal from '../Modals/Modal'
import GeneralContext from '../../context/GeneralContext'
import * as GeneralActions from "../../store/actions/generalActions";

import * as BeneficiarioRepository from "../../services/repositories/beneficiario-repository";

const ListaBeneficiarios = ({ beneficiarios, codTipoBeneficiario, state, setState, recargarLista }) => {
  const { state: generalState, dispatch: generalDispatch } = useContext(GeneralContext)
  let user = generalState.users.filter(user => user.isAuthenticated)[0]
  let prospecto = user.listaProspectos.filter(
    (prospecto) => prospecto.isSelected || prospecto.completado
  )[0]
  let cotizacion = prospecto.cotizaciones.filter(cotizacion => cotizacion.isSelected || cotizacion.completado)[0]

  const initialState = {
    subtitulo: {},
    porcentaje: 0,
    porcentajeFaltante: 100,
    porcentajeEdicion: 0,
    estiloTabla: {},
    habilitarBtnAgregar: true
  }

  const [listaState, setListaState] = useState(initialState)
  const [mostrarBeneficiarioModal, setMostrarBeneficiarioModal] = useState(false)
  const [mostrarConfirmacionModal, setMostrarConfirmacionModal] = useState(false)

  const subtitulos = [
    {
      codTipoBeneficiario: 1,
      titulo: 'Beneficiarios Contingentes',
      parrafo: ''
    },
    {
      codTipoBeneficiario: 2,
      titulo: 'Beneficiarios Principales',
      parrafo: ''
    },
    {
      codTipoBeneficiario: 3,
      titulo: 'Beneficiario Único',
      parrafo: 'Recibirá las cuotas del beneficiario en caso sea mayor de edad, salvo que el Propuesto Asegurado haya optado por recibir directamente el beneficio.'
    },
    {
      codTipoBeneficiario: 4,
      titulo: 'Apoderado',
      parrafo: 'El apoderado para Fondo Universitario (en caso el Asegurado falleciera y el beneficiario sea menor de edad). El parentesco se define en relación al Propuesto Asegurado.'
    }
  ]

  const textos = [
    "Eliminar Beneficiario",
    "¿Estás seguro de eliminar beneficiario?"
  ]

  useEffect(() => {
    let habilitacionBtn = false
    let estiloAux
    let porcentaje = 0
    let subtituloAux = subtitulos.filter(subtituloAux => subtituloAux.codTipoBeneficiario === codTipoBeneficiario)[0]

    //Validando Cantidad de Columnas
    switch (codTipoBeneficiario) {
      case Constantes.COD_TIPO_BENEFICIARIO_PRINCIPAL: {
        state.beneficiariosPrincipales.map(beneficiario => {
          porcentaje = porcentaje + beneficiario.porcentajeBeneficio
          return beneficiario
        })
        if (porcentaje < 100) {
          habilitacionBtn = true
        }
        estiloAux = 'ocho-columnas'

        setState((state) => {
          return {
            ...state,
            porcentajePrincipales: porcentaje
          }
        })
        break
      }

      case Constantes.COD_TIPO_BENEFICIARIO_CONTINGENTE: {
        state.beneficiariosContingentes.map(beneficiario => {
          porcentaje = porcentaje + beneficiario.porcentajeBeneficio
          return beneficiario
        })
        if (porcentaje < 100) {
          habilitacionBtn = true
        }
        estiloAux = 'ocho-columnas'

        setState((state) => {
          return {
            ...state,
            porcentajeContingentes: porcentaje
          }
        })
        break
      }

      case Constantes.COD_TIPO_BENEFICIARIO_UNICO: {
        if (state.beneficiariosUnicos.length < 1) {
          habilitacionBtn = true
        }
        estiloAux = 'siete-columnas'
        break
      }

      case Constantes.COD_TIPO_BENEFICIARIO_APODERADO: {
        if (state.beneficiariosApoderado.length < 1) {
          habilitacionBtn = true
        }
        estiloAux = 'siete-columnas'
        break
      }

      default: {
        console.error('Caso no reconocido')
        break
      }
    }

    setListaState((listaState) => {
      return {
        ...listaState,
        habilitarBtnAgregar: habilitacionBtn,
        estiloTabla: estiloAux,
        porcentaje: porcentaje,
        porcentajeFaltante: 100 - porcentaje,
        subtitulo: subtituloAux
      }
    })
  }, [codTipoBeneficiario, beneficiarios])

  const abrirBeneficiarioModal = (beneficiario) => {
    let beneficiarioAux = null
    let porcentajeEdicion = 0
    if (beneficiario !== null) {
      beneficiarioAux = beneficiario
      porcentajeEdicion = beneficiario.porcentajeBeneficio
    } else {
      beneficiarioAux = null
    }
    setMostrarBeneficiarioModal(true)
    setState((state) => {
      return {
        ...state,
        beneficiarioSeleccionado: beneficiarioAux,
        modalInsertar: true
      }
    })
    setListaState((listaState) => {
      return {
        ...listaState,
        porcentajeEdicion: porcentajeEdicion
      }
    })
  }

  const eliminarBeneficiario = async () => {
    const invocarDeleteBeneficiario = async (idSolicitud, idBeneficiario, flag) => {
      const response = await BeneficiarioRepository.eliminarBeneficiario(idSolicitud, idBeneficiario, flag)
      if(response.error === null) {
        setState((state) => {
          return {
            ...state,
            estaCargando: false,
            beneficiarioSeleccionado: null,
            beneficiarioUnico: codTipoBeneficiario === 3 || codTipoBeneficiario === 4 ? null : state.beneficiarioUnico
          }
        })
      } else {
        generalDispatch(GeneralActions.updateError(response.error, '¡!Alerta'))
      }
    }

    const eliminarBeneficiarioCasos = async () => {
      if (state.tipoCaso === Constantes.TIPO_CASO_1) { //SOLO FU:
        if (state.beneficiarioMultiple) {
          let index = 0
          for (const idBeneficiario of state.beneficiarioSeleccionado.idBeneficiarioArray) {
            await invocarDeleteBeneficiario(state.beneficiarioSeleccionado.idSolicitudArray[index], idBeneficiario, false)
            index++
          }
          await recargarLista()
        } else {
          if (codTipoBeneficiario === Constantes.COD_TIPO_BENEFICIARIO_APODERADO) {
            await invocarDeleteBeneficiario(idsol, idbenef, true)
          } else {
            let index = 0
            for (const idBeneficiario of state.beneficiarioSeleccionado.idBeneficiarioArray) {
              switch (codTipoBeneficiario) {
                case Constantes.COD_TIPO_BENEFICIARIO_UNICO: {
                  await invocarDeleteBeneficiario(state.beneficiarioSeleccionado.idSolicitudArray[index], idBeneficiario, false)
                  break
                }
                default: {
                  break
                }
              }
              index++
            }
          }
          await recargarLista()
        }
      } else if (state.tipoCaso === Constantes.TIPO_CASO_2) { //SOLO DIFERENTE FU
        let index = 0
        for (const idBeneficiario of state.beneficiarioSeleccionado.idBeneficiarioArray) {
          await invocarDeleteBeneficiario(state.beneficiarioSeleccionado.idSolicitudArray[index], idBeneficiario, false)
          index++
        }
        await recargarLista()
      } else if (state.tipoCaso === Constantes.TIPO_CASO_3) { //FU + AP
        if (state.beneficiarioMultiple) {
          let index = 0
          for (const idBeneficiario of state.beneficiarioSeleccionado.idBeneficiarioArray) {
            await invocarDeleteBeneficiario(state.beneficiarioSeleccionado.idSolicitudArray[index], idBeneficiario, false)
            index++
          }
          await recargarLista()
        } else {
          if (codTipoBeneficiario === Constantes.COD_TIPO_BENEFICIARIO_APODERADO) {
            await invocarDeleteBeneficiario(idsol, idbenef, true)
          } else {
            let index = 0
            for (const idBeneficiario of state.beneficiarioSeleccionado.idBeneficiarioArray) {
              switch (codTipoBeneficiario) {
                case Constantes.COD_TIPO_BENEFICIARIO_PRINCIPAL: {
                  await invocarDeleteBeneficiario(state.beneficiarioSeleccionado.idSolicitudArray[index], idBeneficiario, false)
                  break
                }
                case Constantes.COD_TIPO_BENEFICIARIO_CONTINGENTE: {
                  await invocarDeleteBeneficiario(state.beneficiarioSeleccionado.idSolicitudArray[index], idBeneficiario, false)
                  break
                }
                case Constantes.COD_TIPO_BENEFICIARIO_UNICO: {
                  await invocarDeleteBeneficiario(state.beneficiarioSeleccionado.idSolicitudArray[index], idBeneficiario, false)
                  break
                }
                case Constantes.COD_TIPO_BENEFICIARIO_APODERADO: {
                  await invocarDeleteBeneficiario(idsol, idbenef, true)
                  break
                }
                default: {
                  break
                }
              }
              index++
            }
          }
          await recargarLista()
        }
      }
    }

    let idbenef = state.beneficiarioUnico !== null ? state.beneficiarioUnico.idBeneficiario : null
    let idsol = state.beneficiarioUnico !== null ? state.beneficiarioUnico.idSolicitud : null

    generalDispatch(GeneralActions.updateEstadoCargando(true))
    await eliminarBeneficiarioCasos()
    generalDispatch(GeneralActions.updateEstadoCargando(false))
  }

  const confirmarEliminarBeneficiario = (beneficiario) => {
    setMostrarConfirmacionModal(!mostrarBeneficiarioModal)
    setState((state) => {
      return {
        ...state,
        beneficiarioSeleccionado: beneficiario,
        modalBorrar: !mostrarBeneficiarioModal
      }
    })
  }

  //Modo lectura
  let Deshabilitar = (complete) => {
    complete = cotizacion.edicionInhabilitada
    if (complete === true) {
      return true
    } else {
      return false
    }
  }

  //verificar que exista por lo menos un beneficiario principal
  let beneprinci = state.beneficiariosPrincipales !== null && state.beneficiariosPrincipales !== undefined ? state.beneficiariosPrincipales : null
  return (
    <React.Fragment>
      <BeneficiarioModal
        mostrar={mostrarBeneficiarioModal}
        setMostrar={setMostrarBeneficiarioModal}
        codTipoBeneficiario={codTipoBeneficiario}
        state={state}
        setState={setState}
        recargarLista={recargarLista}
        listaState={listaState} />

      <Modal
        mostrarModal={mostrarConfirmacionModal}
        setModal={setMostrarConfirmacionModal}
        doble={true}
        textos={textos}
        accion={() => eliminarBeneficiario()}
      />

      <div className={styles['areadatosprospecto']}>
        {listaState.subtitulo !== undefined
          ? <Subtitle
            sname={listaState.subtitulo.titulo}
            smostrar={true}
            sparrafo={listaState.subtitulo.parrafo} />
          : null
        }

        <div className={styles['areadatosprospecto__accion']}>
          <div>
            <button className={`${styles['btninsertar']} ${(!listaState.habilitarBtnAgregar) || Deshabilitar() === true ? styles['btninsertar-ocultar'] : null}`}
              onClick={listaState.habilitarBtnAgregar ? (e) => abrirBeneficiarioModal(null) : null}
              disabled={(codTipoBeneficiario === Constantes.COD_TIPO_BENEFICIARIO_CONTINGENTE && beneprinci.length === 0) ? true : false}>
              <span>+</span>Insertar
            </button>
          </div>
          {codTipoBeneficiario === Constantes.COD_TIPO_BENEFICIARIO_PRINCIPAL ||
            codTipoBeneficiario === Constantes.COD_TIPO_BENEFICIARIO_CONTINGENTE
            ? <BarraProgreso total={listaState.porcentaje} />
            : null
          }
        </div>
        <div className={styles['datagridprospecto']}>
          <div className={styles['datagridhead']}>
            <div className={`${styles['datagrid-row-head']} ${styles[listaState.estiloTabla]}`}>
              <div className={styles['datagrid-head-item']}>Tipo Doc.</div>
              <div className={styles['datagrid-head-item']}>Nro. Doc.</div>
              <div className={styles['datagrid-head-item']}>Nombres</div>
              <div className={styles['datagrid-head-item']}>Ap. Paterno</div>
              <div className={styles['datagrid-head-item']}>Ap. Materno</div>
              <div className={styles['datagrid-head-item']}>Sexo</div>
              <div className={styles['datagrid-head-item']}>Parentesco</div>
              <div className={styles['datagrid-head-item']}>Fec. Nacimiento</div>
              {codTipoBeneficiario === Constantes.COD_TIPO_BENEFICIARIO_PRINCIPAL ||
                codTipoBeneficiario === Constantes.COD_TIPO_BENEFICIARIO_CONTINGENTE
                ? <div className={styles['datagrid-head-item']}>%</div>
                : null
              }
              <div className={styles['datagrid-head-item']}></div>
            </div>
          </div>
          <div className={styles['datagridbody']}>
            {beneficiarios.map((beneficiario, index) => {
              return (
                <div key={index} className={`${styles['datagrid-row-body']} ${styles[listaState.estiloTabla]}`}>
                  <div className={`${styles['datagrid-body-item']} ${styles['itemtop']}`}>{beneficiario.tipoDocumento.descripcion}</div>
                  <div className={`${styles['datagrid-body-item']} ${styles['itemtop']}`}>{beneficiario.numeroDocumento}</div>
                  <div className={`${styles['datagrid-body-item']} ${styles['itemtop']}`}>{beneficiario.nombres}</div>
                  <div className={`${styles['datagrid-body-item']} ${styles['itemtop']}`}>{beneficiario.apellidoPaterno}</div>
                  <div className={`${styles['datagrid-body-item']} ${styles['itemtop']}`}>{beneficiario.apellidoMaterno}</div>
                  <div className={`${styles['datagrid-body-item']} ${styles['itemtop']}`}>{beneficiario.sexo.descripcion.toString().substring(0, 1)}</div>
                  <div className={`${styles['datagrid-body-item']} ${styles['itemtop']}`}>{beneficiario.parentesco.codigo === 1
                    ? beneficiario.parentesco.descripcion.substring(0, 7) : beneficiario.parentesco.descripcion}</div>
                  <div className={`${styles['datagrid-body-item']} ${styles['itemtop']}`}>{Funciones.formatearFechaTexto(beneficiario.fechaNacimiento)}</div>
                  {codTipoBeneficiario === Constantes.COD_TIPO_BENEFICIARIO_PRINCIPAL ||
                    codTipoBeneficiario === Constantes.COD_TIPO_BENEFICIARIO_CONTINGENTE
                    ? <div className={styles['datagrid-body-item']}>
                      <span className={styles['itemporcentaje']}>{beneficiario.porcentajeBeneficio.toFixed(2)}%</span>
                    </div>
                    : null
                  }
                  <div className={styles['datagrid-body-item']}>
                    <img onClick={(e) => abrirBeneficiarioModal(beneficiario)} alt='' src={imgBtneditar} className={styles['btngrid']}
                      style={{ pointerEvents: Deshabilitar() !== true ? "auto" : "none" }}
                    />
                    &nbsp;&nbsp;
                    <img onClick={(e) => confirmarEliminarBeneficiario(beneficiario)} alt='' src={imgBtneliminar} className={styles['btngrid']}
                      style={{ pointerEvents: Deshabilitar() !== true ? "auto" : "none" }}
                    />
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default ListaBeneficiarios